import { useEffect, useState } from "react";
import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui";

export function PaymentStatusNotification() {
  const [showNotification, setShowNotification] = useState(false);

  useEffect(() => {
    const paymentStatus = localStorage.getItem("payment_status");
    if (paymentStatus === "pending") {
      setShowNotification(true);
    }
  }, []);

  const dismissNotification = () => {
    setShowNotification(false);
    localStorage.removeItem("payment_status");
  };

  if (!showNotification) {
    return null;
  }

  return (
    <Alert className="border border-yellow-300 bg-yellow-100 text-yellow-700 mb-4">
      <AlertCircle className="h-4 w-4" color="#a16207" />
      <AlertTitle>Pagamento em processamento</AlertTitle>
      <AlertDescription className="space-y-1 text-sm text-yellow-700 mt-3">
        Seu pagamento está sendo processado. Você receberá uma confirmação assim
        que for aprovado.
      </AlertDescription>
      <button
        onClick={dismissNotification}
        className="ml-auto text-sm underline"
      >
        Fechar
      </button>
    </Alert>
  );
}
